import {AbstractControlOptions, AsyncValidatorFn, UntypedFormControl, ValidatorFn} from "@angular/forms";

interface CustomFormControlOptions {
  onlySelf?: boolean;
  emitEvent?: boolean;
  emitModelToViewChange?: boolean;
  emitViewToModelChange?: boolean;
}

export class CustomFormControl<T> extends UntypedFormControl {
  override readonly value: T;

  constructor(formState?: T, violation?: string,
              validatorOrOpts?: ValidatorFn | ValidatorFn[] | AbstractControlOptions | null,
              asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null) {
    super(formState, validatorOrOpts, asyncValidator);
  }

  override setValue(value: T, options?: CustomFormControlOptions): void {
    super.setValue(value, options);
  }

  override patchValue(value: T, options?: CustomFormControlOptions): void {
    super.patchValue(value, options);
  }

}
